import React, {useContext, useEffect, useState} from "react";
import {
  Box,
  Stack,
} from "@mui/material";
import {Header} from "./header/Header";
import "./main.css"
import {WebSettingsContext} from "../../context/WebSettingsContext";
import {SignInContext} from "../../context/SignInContext";
import {Outlet, useNavigate} from "react-router-dom";

import {useDebounce} from "../../hooks/useDebounce";

export const MainLayout = () => {
  const {settings} = useContext(WebSettingsContext);
  const {currentUser} = useContext(SignInContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (currentUser !== null) {
      const isAdmin = currentUser?.roles?.includes("admin")
      if (!isAdmin && settings?.underMaintenance) {
        navigate("/under-maintenance");
      }
    }
  }, [settings, currentUser, navigate])


  return (
    <Stack
      direction={"column"} alignItems={"stretch"}
      // className={"bg-primary-gradient"}
      sx={{width: "100vw", height: "100vh", bgcolor: '#f9fafb'}}>
      <Header/>
      {/*<SideBar openDrawer={openDrawer} setOpenDrawer={setOpenDrawer} searchParams={searchParams}*/}
      {/*         onUpdateParams={onUpdateParams}/>*/}
      <Box sx={{flex: 1, overflowY: "auto", position: "relative"}}>
        <Outlet/>
      </Box>
    </Stack>
  )
}
